export default "__VITE_ASSET__BiHl9iH3__"